/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "spos": {
        "nested": {
          "siretbanner": {
            "nested": {
              "GetSiretBannerStatusRequest": {
                "fields": {}
              },
              "GetSiretBannerStatusResponse": {
                "fields": {
                  "type": {
                    "type": "squareup.spos.siretbanner.GetSiretBannerStatusResponse.BannerType",
                    "id": 1,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "BannerType": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "NOT_APPLICABLE": 1,
                      "SIRET_OPTIONAL": 2,
                      "SIRET_REQUIRED": 3
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.spos?.nested?.siretbanner?.nested?.GetSiretBannerStatusRequest && !$root.nested?.squareup?.nested?.spos?.nested?.siretbanner?.nested?.GetSiretBannerStatusResponse && !$root.nested?.squareup?.nested?.spos?.nested?.siretbanner?.nested?.GetSiretBannerStatusResponse?.nested?.BannerType) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE GetSiretBannerStatusRequest @ squareup/spos/siret-banner/api.proto at 8:1
 */
export const GetSiretBannerStatusRequest = $root.lookupType('squareup.spos.siretbanner.GetSiretBannerStatusRequest');
fixType(GetSiretBannerStatusRequest);
Builder.createAndAttachToType(GetSiretBannerStatusRequest);
/**
 * SOURCE GetSiretBannerStatusResponse @ squareup/spos/siret-banner/api.proto at 10:1
 */
export const GetSiretBannerStatusResponse = $root.lookupType('squareup.spos.siretbanner.GetSiretBannerStatusResponse');
fixType(GetSiretBannerStatusResponse, {
  type: {
    required: true
  }
});
Builder.createAndAttachToType(GetSiretBannerStatusResponse);
/**
 * SOURCE BannerType @ squareup/spos/siret-banner/api.proto at 11:3
 */
GetSiretBannerStatusResponse.BannerType = $root.lookupEnum('squareup.spos.siretbanner.GetSiretBannerStatusResponse.BannerType').values;